// ========================================
// Widget: RRHH — Nóminas del Mes (kpiTile 'kpi-nominas' y nominasMes)
// Proporción progresiva de información según span (1, 2 o 3 huecos)
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

// Función auxiliar de renderizado adaptativo para la tarjeta de Nóminas
window.DashboardWidgets.rrhh.renderNominasTile = function(ctx) {
    const {
        id = 'kpi-nominas', span = 1, controls, displayStyle, isEditMode,
        nominasExpectedCount = 0, nominasUploadedCount = 0, nominasPendingCount = 0, nominasPct = 100,
        currentMonthName = new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })
    } = ctx;

    // nominasExpectedCount = a quién le toca nómina en el último mes que ya toca (regla del
    // día 28): clases ese mes o un contrato que lo cubre, como en Nóminas.
    const uploadedCount = nominasUploadedCount;
    const pendingCount = nominasPendingCount;

    // 1 HUECO (1 COLUMNA): MÍNIMA INFORMACIÓN / COMPACTO Y LIMPIO
    const renderSpan1 = () => `
        <div class="dnr-kpi-top">
            <span class="dnr-kpi-label"><span class="dnr-kpi-icon" style="--dnr-widget-hue:250;"><i class="fas fa-file-invoice-dollar"></i></span>Nóminas Subidas</span>
        </div>
        <div class="dnr-kpi-value">${nominasPct}%</div>
        <div class="dnr-kpi-sub">${nominasExpectedCount > 0 ? `${uploadedCount} de ${nominasExpectedCount} de ${currentMonthName}` : `Ninguna nómina que subir de ${currentMonthName}`}</div>
        <div class="dnr-kpi-bar dnr-reveal d-block" style="margin-top: 0.75rem;"><i style="width: ${nominasPct}%;"></i></div>
    `;

    // 2 HUECOS (2 COLUMNAS): INFORMACIÓN INTERMEDIA (DESGLOSE NUMÉRICO Y ESTADO DE ENVÍO)
    const renderSpan2 = () => `
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem; align-items: flex-start; width: 100%;">
            <div>
                <div class="dnr-kpi-top">
                    <span class="dnr-kpi-label"><span class="dnr-kpi-icon" style="--dnr-widget-hue:250;"><i class="fas fa-file-invoice-dollar"></i></span>Nóminas del Mes</span>
                </div>
                <div style="display: flex; align-items: baseline; gap: 0.75rem; margin-top: 0.25rem;">
                    <div class="dnr-kpi-value" style="font-size: 2.75rem; line-height: 1;">${nominasPct}%</div>
                    <span style="font-size: 0.7rem; font-weight: 700; color: #166534; background: rgba(34, 197, 94, 0.12); padding: 2px 7px; border-radius: 4px; white-space: nowrap;">
                        ${uploadedCount} de ${nominasExpectedCount} subidas
                    </span>
                </div>
                <div class="dnr-kpi-sub" style="margin-top: 0.4rem;">Correspondiente a ${currentMonthName}</div>
            </div>

            <div style="border-left: 1px solid var(--dnr-line); padding-left: 1.25rem;">
                <div style="font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: var(--dnr-ink-faint); margin-bottom: 0.5rem; letter-spacing: 0.04em;">
                    Resumen de Envío
                </div>
                <div style="display: flex; flex-direction: column; gap: 0.45rem;">
                    <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.75rem;">
                        <span style="color: var(--dnr-ink); font-weight: 600;">Completadas</span>
                        <span style="font-weight: 700; color: #166534; background: rgba(34,197,94,0.1); padding: 1px 6px; border-radius: 4px;">${uploadedCount}</span>
                    </div>
                    <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.75rem;">
                        <span style="color: var(--dnr-ink); font-weight: 600;">Pendientes</span>
                        <span style="font-weight: 700; color: #b45309; background: rgba(245,158,11,0.1); padding: 1px 6px; border-radius: 4px;">${pendingCount}</span>
                    </div>
                </div>
            </div>
        </div>
    `;

    // 3 HUECOS (3 COLUMNAS): INFORMACIÓN COMPLETA (METRICAS + BARRA DE PROGRESO DE ENVÍO + ACCIONES/HISTÓRICO)
    const renderSpan3 = () => `
        <div style="display: grid; grid-template-columns: 1fr 1.1fr 1.2fr; gap: 1.5rem; align-items: flex-start; width: 100%;">
            <!-- Columna 1: Porcentaje y Total -->
            <div>
                <div class="dnr-kpi-top">
                    <span class="dnr-kpi-label"><span class="dnr-kpi-icon" style="--dnr-widget-hue:250;"><i class="fas fa-file-invoice-dollar"></i></span>Nóminas Globales</span>
                </div>
                <div style="display: flex; align-items: center; gap: 0.85rem; margin-top: 0.25rem;">
                    <div class="dnr-kpi-value" style="font-size: 3rem; line-height: 1;">${nominasPct}%</div>
                    <div style="display: flex; flex-direction: column; gap: 3px;">
                        <span style="font-size: 0.725rem; font-weight: 700; color: #166534; background: rgba(34, 197, 94, 0.12); padding: 3px 8px; border-radius: 6px; white-space: nowrap;">
                            ${uploadedCount} Archivos Subidos
                        </span>
                        <span style="font-size: 0.725rem; font-weight: 700; color: #b45309; background: rgba(245,158,11,0.1); padding: 3px 8px; border-radius: 6px; white-space: nowrap;">
                            ${pendingCount} Pendientes
                        </span>
                    </div>
                </div>
                <div class="dnr-kpi-sub" style="margin-top: 0.5rem;">Nóminas de ${currentMonthName}: clases ese mes o contrato</div>
            </div>

            <!-- Columna 2: Estado y Progreso de Envío -->
            <div style="border-left: 1px solid var(--dnr-line); padding-left: 1.25rem;">
                <div style="font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: var(--dnr-ink-faint); margin-bottom: 0.5rem; letter-spacing: 0.04em;">
                    Progreso del Mes (${currentMonthName})
                </div>
                <div style="margin-bottom: 0.5rem;">
                    <div style="display: flex; justify-content: space-between; font-size: 0.725rem; margin-bottom: 3px;">
                        <span style="font-weight: 600; color: var(--dnr-ink);">Avance total</span>
                        <span style="font-weight: 700; color: var(--dnr-teal-700);">${nominasPct}%</span>
                    </div>
                    <div style="height: 6px; background: var(--dnr-line); border-radius: 4px; overflow: hidden;">
                        <div style="height: 100%; width: ${nominasPct}%; background: var(--dnr-teal-500); border-radius: 4px;"></div>
                    </div>
                </div>
            </div>

            <!-- Columna 3: Accesos Rápidos y Gestión -->
            <div style="border-left: 1px solid var(--dnr-line); padding-left: 1.25rem;">
                <div style="font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: var(--dnr-ink-faint); margin-bottom: 0.5rem; letter-spacing: 0.04em;">
                    Gestión de Ficheros
                </div>
                <div style="display: flex; flex-direction: column; gap: 0.4rem;">
                    <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.75rem; background: var(--dnr-surface-sunken, #f8fafc); border: 1px solid var(--dnr-line); padding: 0.45rem 0.65rem; border-radius: 6px;">
                        <span style="font-weight: 600; color: var(--dnr-ink);"><i class="fas fa-upload" style="color: var(--dnr-teal-600); margin-right: 4px;"></i> Subir lote de nóminas</span>
                        <i class="fas fa-chevron-right" style="font-size: 0.6rem; color: var(--dnr-ink-mute);"></i>
                    </div>
                    <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.75rem; background: var(--dnr-surface-sunken, #f8fafc); border: 1px solid var(--dnr-line); padding: 0.45rem 0.65rem; border-radius: 6px;">
                        <span style="font-weight: 600; color: var(--dnr-ink);"><i class="fas fa-history" style="color: #6366f1; margin-right: 4px;"></i> Historial anterior</span>
                        <i class="fas fa-chevron-right" style="font-size: 0.6rem; color: var(--dnr-ink-mute);"></i>
                    </div>
                </div>
            </div>
        </div>
    `;

    let content = renderSpan1();
    if (span === 2) content = renderSpan2();
    if (span === 3) content = renderSpan3();

    return `
        <div id="widget-${id}" data-widget-id="${id}" draggable="${isEditMode ? 'true' : 'false'}" class="dnr-card dashboard-widget-card ${isEditMode ? 'edit-mode' : 'dnr-clickable'}" style="grid-column: span ${span}; min-width: 0; display: ${displayStyle}; flex-direction: column; cursor: ${isEditMode ? 'grab' : 'pointer'}; position: relative; border: ${isEditMode ? '2px dashed var(--dnr-teal-500)' : '1px solid var(--dnr-line)'}; padding: 1.15rem 1.35rem;" ${isEditMode ? '' : `${UIEvents.attr("click", function(event,captured){App.navigate('nominas');}, [])}`}>
            ${controls}
            ${content}
        </div>`;
};

window.DashboardWidgets.rrhh.nominasMes = function(ctx) {
    return window.DashboardWidgets.rrhh.renderNominasTile(ctx);
};
